import React,{useEffect} from 'react';
import Layout from '../layout';
import {css} from 'emotion';
import {useDispatch,useSelector} from 'react-redux';
import {getListDeclarationBoat} from '../../redux/actions/formActions';
import moment from 'moment';
import 'moment/locale/fr';  // without this line it didn't work
moment.locale('fr')

const ResultFormListPage = (props) =>{
const dispatch = useDispatch();

const popkey = useSelector(state=>state.user.popkey);
const list_declaration = useSelector(state => state.form.list_declaration)
const number = useSelector(state => state.form.number)

  useEffect(()=>{
    dispatch(getListDeclarationBoat(popkey));
  },[])


  return(
    <Layout location={props.location}>
      <div className={css`margin:0 auto;max-width:678px`}>
          <div className={css`background-color:white;height:60px;line-height:60px;text-align:center;color:#3f4d6e;font-weight:600;`}>{number == 0 ?'Vous ne pouvez plus louer de navire cette année': `Il vous reste ${number} locations de navire cette année`}</div>

          <div className={css`height:40px;background-color:#0085C6;color:white;line-height:40px;display:flex;`}>
            <div className={css`width:100px;box-sizing:border-box;border-right:1px solid white;box-sizing:border-box;padding-left:10px;overflow:hidden;text-overflow: ellipsis;`}>Ref</div>
            <div className={css`flex:1;border-right:1px solid white;box-sizing:box-sizing:border-box;padding-left:10px;overflow:hidden;text-overflow: ellipsis;`}>Immatriculation</div>
            <div className={css`flex:1;border-right:1px solid white;box-sizing:border-box;padding-left:10px;overflow:hidden;text-overflow: ellipsis;`}>Nom du Bateau</div>
            <div className={css`flex:1;box-sizing:border-box;padding-left:10px;oveflow:hiddent;text-overflow: ellipsis;`}>Date</div>
          </div>

          {
            (list_declaration && list_declaration.length>0) ? list_declaration.map((item,key)=>{
              return <div key={key} className={css`border-top:1px solid #e3e3e3;display:flex;background-color:white;line-height:40px`}>
                          <div className={css`font-size:14px;box-sizing:border-box;padding-left:10px;width:100px;border-right:1px solid #e3e3e3;overflow:hidden;text-overflow: ellipsis;color:#3f4d6e`}>{`${item.ref}`}</div>
                          <div className={css`font-size:14px;box-sizing:border-box;padding-left:10px;flex:1;border-right:1px solid #e3e3e3;overflow:hidden;text-overflow: ellipsis;color:#3f4d6e`}>{`${item.boat_immatriculation}`}</div>
                          <div className={css`font-size:14px;box-sizing:border-box;padding-left:10px;flex:1;border-right:1px solid #e3e3e3;overflow:hidden;text-overflow: ellipsis;color:#3f4d6e`}>{`${item.boat_name}`}</div>
                          <div className={css`font-size:14px;box-sizing:border-box;padding-left:10px;flex:1;overflow:hidden;text-overflow: ellipsis;color:#3f4d6e`}>{`${moment(item.date).format('L')}`}</div>


                      </div>
            })
            :
            <div className={css`text-align:center;height:100px;background-color:white;width:100%;display:flex;align-items:center;justify-content:center`}>Vous n'avez pas de déclaration</div>
          }
      </div>

    </Layout>
  )
}

export default ResultFormListPage;
